<template>
  <pt-related-label class="pt-related-label__page"></pt-related-label>
</template>

<script>
import PtRelatedLabel from 'cps/mall-manage/recommend-manage/pt-label-manage/pt-related-label/withData'
export default {
  name: 'pt-related-label__view',
  components: {
    'pt-related-label': PtRelatedLabel
  }
}
</script>
